import { styled } from 'styled-components';

export const FormGroupContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizes.md};
  margin-bottom: ${({ theme }) => theme.sizes.md};

  > * {
    flex: 1 1 0;
    min-width: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: ${({ theme }) => theme.sizes.sm};
  }
`;

export const FormGroupItem = styled.div<{ span?: number }>`
  flex: ${({ span = 1 }) => `${span} ${span} 0`};
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex: 1 1 auto;
    width: 100%;
  }
`;
